var _style, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderHomeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,7.8C5,4.6,7.6,2,11,2c3.4,0,6,2.6,6,5.8c0,1.8-0.8,3.7-1.9,5.3c-1.1,1.6-2.5,3-3.7,3.8 c-0.3,0.2-0.6,0.2-0.8,0c-1.2-0.8-2.6-2.2-3.7-3.8C5.8,11.5,5,9.6,5,7.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 8,
    r: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,14.1c1,0.2,1.8,0.5,2.4,0.9c0.6,0.4,1.2,0.9,1.2,1.7c0,0.7-0.5,1.2-1,1.6c-0.5,0.4-1.2,0.7-2,0.9 c-1.6,0.5-3.7,0.8-6,0.8c-2.3,0-4.5-0.3-6-0.8c-0.8-0.2-1.5-0.5-2-0.9c-0.5-0.3-1-0.9-1-1.6c0-0.8,0.6-1.3,1.2-1.7 c0.6-0.4,1.4-0.7,2.4-0.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderHomeicon);
export default __webpack_public_path__ + "static/media/loader-homeicon.ed3057995dd6325a4d88431caf1bcea1.svg";
export { ForwardRef as ReactComponent };